export class NewsAutoReload {

    constructor(newsToggle: HTMLInputElement) {

        newsToggle.addEventListener('change', () => {

            if (this.checkIfToggleIsOn(newsToggle)) {
                this.enableCookie();
                this.reloadNewsList();
            } else {
                this.disableCookies();
            }


            console.log('works');
            console.log(this.checkCookieState());
            console.log(this.checkIfToggleIsOn(newsToggle));
        });

    }

    checkCookieState():boolean {
        const cookie = this.getCookieByName('newsAutoReload');
        console.log(cookie);

        if (cookie == 'true') {
            return true;
        } else {
            return false;
        }
    }

    getCookieByName(name) {
        const cookieString = document.cookie;
        const cookies = cookieString.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                return cookie.substring(name.length + 1);
            }
        }
        return null;
    }

    checkIfToggleIsOn(newsToggle: HTMLInputElement):boolean {
        return newsToggle.checked;
    }

    enableCookie() {
        document.cookie = "newsAutoReload=true";
    }

    disableCookies() {
        document.cookie = "newsAutoReload=false";
    }

    reloadNewsList() {

    }
}
